export enum InvoiceOriginEnum {
    Api = 'api',
    Email = 'email',
    Import = 'import',
    Internal = 'internal',
    Upload = 'upload',
}

/** Option de filtre multi-select sur l'origine (1 origine = 1 option). */
export interface InvoiceOriginOption {
    value: InvoiceOriginEnum;
    label: string;
    icon: string;
}
